import { useCallback, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
import SearchFiltersDesktop from '../SearchFiltersPrimary/SearchFiltersDesktop';
import SearchFiltersPopUp from '../../../containers/SearchPage/SearchFiltersPopUp/SearchFiltersPopUp';
import { useHistory, useLocation } from 'react-router-dom';
import { LISTING_CATEGORIES } from '../../../containers/EditListingPage/listingTypeConfig';
import { Box, HStack } from '@chakra-ui/react';

export const categoryLevel1 = 'pub_categoryLevel1';
export const categoryLevel2 = 'pub_categoryLevel2';
export const categoryLevel3 = 'pub_categoryLevel3';

const evaluateActiveCategoryIds = params => {
  const ids = [];

  const level1 = params.get(categoryLevel1);
  const level2 = params.get(categoryLevel2);
  const level3 = params.get(categoryLevel3);

  if (level1) ids.push(level1);
  if (level2 && level1 === LISTING_CATEGORIES.SPORTS_CLUB.id) {
    ids.push(level2);
  } else if (level2) {
    params.delete(categoryLevel2);
  }
  if (level3) ids.push(level3);

  return ids;
};

const SearchFiltersSection = ({
  searchInProgress,
  availableFilters,
  totalItems,
  mobileView,
  isModalOpenMobile,
  onClose,
  sortByComponent,
  listingsAreLoaded,
  selectedFiltersCount,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const history = useHistory();
  const location = useLocation();

  const filtersByKey = useMemo(() => {
    const map = {};

    availableFilters.forEach(filter => {
      map[filter.key] = filter;
    });

    return map;
  }, [availableFilters]);

  const removeInvalidCategoryFilters = (params, filtersByKey) => {
    const activeCategoryIds = evaluateActiveCategoryIds(params);

    Object.entries(filtersByKey).forEach(([key, filter]) => {
      const categoryConfig = filter.categoryConfig;
      if (!categoryConfig?.limitToCategoryIds) return;

      const isValid = categoryConfig.categoryIds.some(id => activeCategoryIds.includes(id));

      if (!isValid) {
        params.delete(`pub_${key}`);
      }
    });
  };

  const updateQueryParams = useCallback(
    debounce(updates => {
      const params = new URLSearchParams(location.search);

      // 1. Apply incoming updates
      Object.entries(updates).forEach(([key, value]) => {
        if (!value || (Array.isArray(value) && value.length === 0)) {
          params.delete(key);
        } else {
          params.set(key, value);
        }
      });

      // 2. If ANY category level changed → cleanup
      const categoryKeys = [categoryLevel1, categoryLevel2, categoryLevel3];

      const categoryChanged = categoryKeys.some(key => key in updates);

      if (categoryChanged) {
        removeInvalidCategoryFilters(params, filtersByKey);
      }

      if (window.plausible) {
        window.plausible('Search Applied Filters', {
          props: {
            ...Object.fromEntries(params),
          },
        });
      }

      history.push({
        pathname: location.pathname,
        search: params.toString(),
      });
    }, 200),
    [location.search, filtersByKey]
  );

  return (
    <Box w="100%" minW={0}>
      {!mobileView && (
        <SearchFiltersDesktop
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          updateQueryParams={updateQueryParams}
          mobileView={mobileView}
          sortByComponent={sortByComponent}
          searchInProgress={searchInProgress}
          listingsAreLoaded={listingsAreLoaded}
          totalItems={totalItems}
          selectedFiltersCount={selectedFiltersCount}
        />
      )}
      <SearchFiltersPopUp
        isOpen={isModalOpenMobile || isModalOpen}
        setIsOpen={setIsModalOpen}
        totalItems={totalItems}
        searchInProgress={searchInProgress}
        availableFilters={availableFilters}
        updateQueryParams={updateQueryParams}
        onClose={onClose}
      />
    </Box>
  );
};

export default SearchFiltersSection;
